import { useEffect, useState } from "react";
import { NewsCard } from "@/components/news/NewsCard";
import { newsApi } from "@/components/news/newsUtils";
import { CtaLink, Reveal } from "@/components/site/Primitives";

// Shows the 3 newest published articles; renders nothing until at least one exists.
export const LatestNews = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    newsApi.get("", { params: { limit: 3 } })
      .then((r) => setItems(Array.isArray(r.data?.items) ? r.data.items : []))
      .catch(() => setItems([]));
  }, []);
  if (!items.length) return null;
  return (
    <section className="pb-24 md:pb-32" data-testid="home-latest-news">
      <div className="container-x">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <Reveal className="max-w-2xl">
            <p className="eyebrow">News & Events</p>
            <h2 className="mt-5 text-3xl font-extrabold leading-[1.08] tracking-tight text-navy sm:text-4xl">Latest From the Foundation</h2>
          </Reveal>
          <CtaLink to="/news" variant="btn-ghost" testId="home-latest-news-view-all">View All News & Events</CtaLink>
        </div>
        <ul className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {items.map((a) => <li key={a.slug}><NewsCard a={a} testPrefix="home-news-card" /></li>)}
        </ul>
      </div>
    </section>
  );
};
